import { IconPreview } from "components/icons/IconPreview";
import * as React from "react";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";


export const IconButtonPreview: React.FC<MprcIconButtonProps> = ({ title, children, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonPreview.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconPreview fixedWidth  />
            {children}
        </MprcIconButton>
    );
};
